import { AbstractControl, ValidationErrors } from '@angular/forms';

export const PasswordStrengthValidator = function (control: AbstractControl): ValidationErrors | null {
    const value: string = control.value || '';

    if (!value) {
        return null;
    }

    // const upperCaseCharacters = /[A-Z]+/g;
    // if (upperCaseCharacters.test(value) === false) {
    //     return { passwordStrength: 'validation.passwordStrengthValidation.upperCase' };
    // }

    // const lowerCaseCharacters = /[a-z]+/g;
    // if (lowerCaseCharacters.test(value) === false) {
    //     return { passwordStrength: 'validation.passwordStrengthValidation.lowerCase' };
    // }

    // const numberCharacters = /[0-9]+/g;
    // if (numberCharacters.test(value) === false) {
    //     return { passwordStrength: 'validation.passwordStrengthValidation.number' };
    // }

    // const specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
    // if (specialCharacters.test(value) === false) {
    //     return { passwordStrength: 'validation.passwordStrengthValidation.special' };
    // }

    // if (value.length < 8) {
    //     return { passwordStrength: 'validation.passwordStrengthValidation.minLength' };
    // }

    return null;
};
